import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../environments/environment';


const authToken = JSON.parse(localStorage.getItem('user_token'));
const http_options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `${authToken}`
  })
};

class LRForm {
  lr_date: string;
  consignor: string;
  loading: string;
  station: string;
  LRNumber: string;
  on_account : string;
  party:string;
  truck_number: string;
  owned_by: string;
  sto_number : string;
  freight_rate : string;
  freight_amt : string;
  advance_paid : string;
  balance : string;
  diesel_amt : string;
  product: string;
  weight:string;
  qty_bags:string;
  rr_date : string;
  rr_number: string;
}

@Injectable()
export class LRFormService {

private url = environment.url;


  constructor(private http: HttpClient) { }


  addNewLR(form): Observable<string>{
  	return this.http.post<string>(this.url + '/lrform/submit', form, http_options);
  }

  getLRFormWith(id:string): Observable<LRForm[]> {
    console.log (this.http.get<LRForm[]>(this.url + '/lrform/get/' + id,http_options));
    return this.http.get<LRForm[]>(this.url + '/lrform/get/' + id,http_options);
  }
  getLRFormByRRNumber(rr_number:string): Observable<LRForm[]> {
    return this.http.get<LRForm[]>(this.url + '/lrform/get/byrrnumber/' + rr_number,http_options);
  }
  getLastLRNumber(id:string): Observable<LRForm[]> {
    return this.http.get<LRForm[]>(this.url + '/lrform/getlastlrnumber/' + id,http_options);
  }

}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/l-r-form.service.ts